import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useGetFeedTeamsQuery } from '@/api/feed/getFeedTeams';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Breadcrumbs } from '@/components/layout/Breadcrumbs';
import { PageContainer } from '@/components/layout/PageContainer';
import { PlayerInformationSection, PlayerStatsSection } from '@/components/forms/player';

export const Route = createFileRoute('/dashboard/sports/$id/players/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  // Convert route id to lowercase for API (NFL -> nfl, NBA -> nba)
  const leagueId = id.toLowerCase();

  const { data: feedTeams = [] } = useGetFeedTeamsQuery(leagueId);

  // Adapt FeedTeam to the Team interface expected by PlayerInformationSection
  const teams = useMemo(() => {
    return feedTeams.map(team => ({
      id: team.externalId,
      name: team.name,
    }));
  }, [feedTeams]);

  const sportName = id.toUpperCase();

  return (
    <PageContainer>
      <Breadcrumbs
        overrides={{ sports: 'Sports', [id]: id.toUpperCase() }}
        pathOverrides={{ sports: `/dashboard/sports/${id}` }}
      />
      <div className="flex gap-4 items-center mb-6 flex-wrap">
        <div className="flex items-center gap-2">
          <Settings className="h-5 w-5 text-gray-500" />
          <h1 className="text-2xl font-semibold">
            {sportName} {'>'} Players {'>'} Add Player
          </h1>
        </div>

        <div className="flex gap-2 ml-auto">
          <Button
            variant="outline"
            onClick={() => navigate({ to: '/dashboard/sports/$id/players', params: { id } })}
          >
            Cancel
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" disabled>
            Save
          </Button>
        </div>
      </div>

      <div className="space-y-6">
        <PlayerInformationSection sportName={sportName} teams={teams} disabled />

        <PlayerStatsSection sport={sportName} />
      </div>
    </PageContainer>
  );
}
